// @mui
import Popover from '@mui/material/Popover';
import { getPosition } from './utils';
import { StyledArrow } from './styles';

// ----------------------------------------------------------------------

export default function CustomPopover({
	open,
	children,
	arrow = 'top-right',
	hiddenArrow,
	sx,
	isMobile = false,
	...other
}) {
	const { anchorOrigin, transformOrigin } = getPosition(arrow);

	// Override positioning for mobile to show at bottom
	const mobileAnchorOrigin = isMobile ? { vertical: 'bottom', horizontal: 'center' } : anchorOrigin;
	const mobileTransformOrigin = isMobile ? { vertical: 'bottom', horizontal: 'center' } : transformOrigin;

	return (
		<Popover
			open={Boolean(open)}
			anchorEl={open}
			anchorOrigin={mobileAnchorOrigin}
			transformOrigin={mobileTransformOrigin}
			sx={{
				...(isMobile && {
					'& .MuiPaper-root': {
						position: 'fixed !important',
						bottom: '16px !important',
						top: 'auto !important',
						left: '50% !important',
						transform: 'translateX(-50%) !important',
						margin: '0 !important',
					}
				}),
				...sx
			}}		
			{...other}
		>
			{!hiddenArrow && !isMobile && <StyledArrow arrow={arrow} />}

			{children}
		</Popover>
	);
}
